import React, { FC } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';

import { useMessageCenterEdit } from 'src/features/message-center/providers';
import { AddIcon } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

export const MessageCenterListHeader: FC = () => {
  const { t } = useTranslate();

  const { onNewMessage } = useMessageCenterEdit();

  return (
    <Stack direction="row" gap={2} justifyContent="space-between" alignItems="center">
      <h2>{t('messageCenter.messageCenter')}</h2>
      <LoadingButton variant="contained" startIcon={<AddIcon />} onClick={onNewMessage}>
        {t('messageCenter.message')}
      </LoadingButton>
    </Stack>
  );
};
